import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
// import { AuctionsFilter } from 'src/app/features/bidders/core/enums/auctions_filter';
import { RequestModal } from '../../../features/items-requests/core/class/RequestModal';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { ItemRequestsService } from '../../../features/items-requests/core/service/item-requests.service';
import { RequestTyeps } from '../../../features/items-requests/core/enums/request_types';
import { MatDialog } from '@angular/material/dialog';
import { SubmitRequestComponent } from 'src/app/features/items-requests/component/submit-request/submit-request.component';
import { ApiUserService } from 'src/app/features/user-managment/core/service/api-user.service';
import * as moment from 'moment';
import { SuccessAddItemComponent } from 'src/app/features/rooms/component/createAuction/success-add-item/success-add-item.component';

@Component({
  selector: 'app-list-requests',
  templateUrl: './list-requests.component.html',
  styles: [
  ]
})
export class ListRequestsComponent implements OnInit {
  @Input() UsedBySelector: boolean = false;
  loadingData: boolean = false;
  IsRoom: any;
  Loading: any;
  loadMore: boolean = false;
  RequestList: any;
  FilterItems: any = [
    {
      key: RequestTyeps.NEW,
      value: "bidders.New",
      canLoadMore: true,
      sortBy: [{ key: "bidders.Most recent", value: "DESC", type: "created_at" },
      { key: "bidders.Oldest", value: "ASC", type: "created_at" }],
      count: 0
    },
    {
      key: RequestTyeps.APPROVED,
      value: "bidders.Approved",
      canLoadMore: true,
      sortBy: [{ key: "bidders.Most recent", value: "DESC", type: "created_at" }, { key: "bidders.Oldest", value: "ASC", type: "created_at" }, { key: "bidders.sooner one will end", value: "ASC", type: "date" }, { key: "bidders.last one will end", value: "DESC", type: "date" },],
      count: 0
    },
    {
      key: RequestTyeps.DECLINED,
      value: "bidders.Declined",
      canLoadMore: true,
      sortBy: [{ key: "bidders.Most recent", value: "DESC", type: "created_at" }, { key: "bidders.Oldest", value: "ASC", type: "created_at" }],
      count: 0
    }
  ];
  RequestListModal: RequestModal = {
    search: '',
    perPage: 10,
    page: 0,
    status: RequestTyeps.NEW,
    sort: "DESC",
    sortBy: "created_at"
  }
  total: any;
  sortingList: any = this.FilterItems[2].sortBy;
  sortByText: any = this.FilterItems[2].sortBy[0].key;
  categoriesList: any;
  showFilter: boolean = false;
  showSearch: boolean = false;
  userID!: string;

  BiddersModal: {
    perPage: number,
    page: number,
    status: 'active',
    sort: 'ASC',
    sortBy: 'name',
    search: string
  } = {
      perPage: 10,
      page: 1,
      status: 'active',
      sort: 'ASC',
      sortBy: 'name',
      search: ''
    }
  BiddersList: any[] = [];
  LoadingBidders: boolean = false;
  BidderPageCount: number = 0;
  authUserIsAdmin: boolean = false;
  constructor(private auctionService: AuctionsService,
    private _ItemRequestsService: ItemRequestsService,
    private _activeRoute: ActivatedRoute,
    private _config: ConfigService,
    private _UserService: ApiUserService,
    private dialog: MatDialog) {
    _config.getAuthUserInfo()?.user?.role_code == "Admin"
  }

  ngOnInit(): void {
    let authUser: any = localStorage.getItem("auth");
    this.userID = this._activeRoute.snapshot.params['id'] ? this._activeRoute.snapshot.params['id'] : JSON.parse(authUser)?.user?.id;

    if (JSON.parse(authUser)?.user?.role_code != "General") {
      this.getBidders();
    }
    this.GetRequests();

    this.Getcategories();
  }

  GetRequests() {
    console.log(this.RequestListModal);
    this.RequestList = [];
    this.total = 0;
    let modal = { ...this.RequestListModal }
    modal.page += 1
    this.loadingData = true

    if (this.UsedBySelector) {
      modal.created_by = this.userID;
    }
    this._ItemRequestsService.GetAllRequests(modal).subscribe({
      next: (res) => {
        this.loadMore = false
        this.loadingData = false

        this.RequestList = res.data.list;

        this.FilterItems[0].count = res?.data?.total_new
        this.FilterItems[1].count = res?.data?.total_approved
        this.FilterItems[2].count = res?.data?.total_rejected
        this.total = res.data.total
      },
      error: (err) => {
        this.loadMore = false
        this.loadingData = false
        this._config.showErrors(err);
      }
    })



  }

  onSelectType(item: any, index: number) {
    this.RequestListModal.status = item.key;
    this.RequestListModal.page = 0;
    this.RequestListModal.sort = item.sortBy[0].value;
    this.RequestListModal.sortBy = item.sortBy[0].type;
    this.sortingList = item.sortBy;
    this.sortByText = item.sortBy[0].key

    this.GetRequests()
  }

  OnSelectSort(item: any) {
    this.RequestListModal.sort = item.value;
    this.RequestListModal.sortBy = item.type;
    this.sortByText = item.key;
    this.GetRequests()
  }

  onClearFiltrs() {
    this.RequestListModal.created_from = "";
    this.RequestListModal.created_to = "";
    delete this.RequestListModal?.category_id;
    delete this.RequestListModal?.created_by;
    this.BiddersModal.search = '';
    this.GetRequests()
  }


  onCancelSearch() {
    this.showSearch = !this.showSearch
    if (this.RequestListModal.search && !this.showSearch) {
      this.RequestListModal.search = ''
      this.GetRequests()
    }
  }

  onApplyDate(type: 'start' | 'end') {
    switch (type) {
      case 'start':
        this.RequestListModal.created_from
        break;
      case 'end':

        break;
    }
  }


  Getcategories() {
    this.loadingData = true;
    this.auctionService.getCategories().subscribe(
      response => {
        this.loadingData = false;
        this.categoriesList = response.data.list
      },
      error => {
        this.loadingData = false;
        this._config.showErrors(error)
      }
    )
  }

  handlePageEvent(event: PageEvent) {
    this.RequestListModal.perPage = event.pageSize;
    this.RequestListModal.page = event.pageIndex;
    this.GetRequests();
  }

  OnNavigate(request_id: string) {
    let URL: string;
    if (this.UsedBySelector) {
      URL = '/request/'
    } else {
      URL = '/admin/requests/'
    }
    this._config._router.navigate([URL, request_id])

    // const url = this._config._router.createUrlTree([URL, request_id])
    // window.open(url.toString())
  }

  SubmitRequest() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(SubmitRequestComponent, {
      width: 'auto',
      //minWidth: "400px",
      data: { Title: this._config.translate.instant('items-requests.Submit Request (add your Item for Auction)'), ButtonText: this._config.translate.instant('items-requests.Submit Request') },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res === true) {
        this.onSuccessAdd()
      }
    })
  }

  onSuccessAdd() {
    const dialogRef = this.dialog.open(SuccessAddItemComponent, {
      width: '550px',
      data: { type: 'request' },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.GetRequests();
    });

  }

  getBidders() {
    this.LoadingBidders = true;
    this._UserService.allUser(this.BiddersModal).subscribe({
      next: (data) => {
        this.LoadingBidders = false;
        // this.length = data.data.total;
        this.BiddersList = this.BiddersList.concat(data.data.list);
        this.BidderPageCount = Math.ceil(
          data.data.count_active / this.BiddersModal.perPage
        );
      }, error: (error) => {
        this.LoadingBidders = false;
        this._config.showErrors(error);
      }
    });
  }

  onGetSearchBiddersList(firstTime: boolean) {

    if (firstTime) {
      this.BiddersList = []
      this.BiddersModal.page = 1
      this.getBidders()
    } else {
      if (this.BiddersModal.page <= this.BidderPageCount - 1) {
        this.BiddersModal.page += 1;
        this.getBidders()
      }
    }
  }


  changeTime(value: any) {
    // console.log("On Change Time", value);
    return moment(value).format();
  }

}
